import { render, staticRenderFns } from "./ChildrenOverview.vue?vue&type=template&id=5a4e8112&scoped=true"
import script from "./ChildrenOverview.vue?vue&type=script&lang=js"
export * from "./ChildrenOverview.vue?vue&type=script&lang=js"
import style0 from "./ChildrenOverview.vue?vue&type=style&index=0&id=5a4e8112&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a4e8112",
  null
  
)

export default component.exports